"use client";

import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

export function FAQAccordion({ items }: FAQAccordionProps) {
  return (
    <AccordionPrimitive.Root type="multiple" className="flex flex-col gap-2">
      {items.map((item, i) => (
        <AccordionPrimitive.Item
          key={i}
          value={String(i)}
          className="rounded-xl border border-rose-100 bg-white overflow-hidden"
        >
          <AccordionPrimitive.Header>
            <AccordionPrimitive.Trigger
              className={cn(
                "flex w-full items-center justify-between px-5 py-4 text-sm font-semibold text-[#1F2937] text-left",
                "hover:bg-rose-50 transition-colors",
                "data-[state=open]:text-[#E11D48] data-[state=open]:bg-rose-50",
                "[&[data-state=open]>svg]:rotate-180"
              )}
            >
              {item.question}
              <ChevronDown className="h-4 w-4 shrink-0 text-[#E11D48] transition-transform duration-200" />
            </AccordionPrimitive.Trigger>
          </AccordionPrimitive.Header>
          <AccordionPrimitive.Content className="overflow-hidden text-sm text-gray-600 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0">
            <div className="px-5 pb-4 pt-0 leading-relaxed">
              {item.answer}
            </div>
          </AccordionPrimitive.Content>
        </AccordionPrimitive.Item>
      ))}
    </AccordionPrimitive.Root>
  );
}
